import React from 'react'
import { Link } from 'react-router'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'

export default class LinkUpdateEps extends React.Component {
  render () {
    var url = 'eps/' + this.props.rowData.Nombre
    return (
      <Link to={url}>
        <img src={EditIcon}/>
      </Link>
    )
  }
}

/* Validate Props */
LinkUpdateEps.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/EPS/SearchEps/LinkUpdateEps.js